(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-extension-quiz"] && !Shopify.designMode) return;
  try {
    
  class ExtensionQuiz extends HTMLElement {
    connectedCallback() {
      this.questions = [...this.querySelectorAll('[data-quiz-question]')];
      this.results = [...this.querySelectorAll('[data-result]')];
      this.scores = { clip: 0, tape: 0, ring: 0 };
      this.current = 0;
      this.querySelectorAll('[data-quiz-answer]').forEach((button) => {
        button.addEventListener('click', () => this.answer(button));
      });
      this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this.restart());
      this.updateProgress();
    }

    answer(button) {
      const [key, points] = button.dataset.score.split(':');
      this.scores[key] += Number(points || 1);
      this.questions[this.current].hidden = true;
      this.current += 1;
      if (this.current < this.questions.length) {
        this.questions[this.current].hidden = false;
        this.updateProgress();
        return;
      }
      this.showResult();
    }

    updateProgress() {
      const percent = ((this.current + 1) / this.questions.length) * 100;
      this.style.setProperty('--quiz-progress', `${percent}%`);
      const text = this.querySelector('[data-quiz-progress-text]');
      if (text) text.textContent = `${this.current + 1} / ${this.questions.length}`;
    }

    showResult() {
      const winner = Object.entries(this.scores).sort((a, b) => b[1] - a[1])[0][0];
      this.querySelector('[data-quiz-results]').hidden = false;
      this.results.forEach((result) => {
        result.hidden = result.dataset.result !== winner;
      });
      this.querySelector('.ve-quiz__progress').hidden = true;
    }

    restart() {
      this.scores = { clip: 0, tape: 0, ring: 0 };
      this.current = 0;
      this.querySelector('[data-quiz-results]').hidden = true;
      this.querySelector('.ve-quiz__progress').hidden = false;
      this.questions.forEach((question, index) => {
        question.hidden = index !== 0;
      });
      this.updateProgress();
    }
  }

  if (!customElements.get('extension-quiz')) customElements.define('extension-quiz', ExtensionQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-guide-page"] && !Shopify.designMode) return;
  try {
    
  class VeGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.selectorEnabled !== 'true') return;
      this.querySelectorAll('[data-guide-choice]').forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });
    }

    select(activeButton) {
      const target = activeButton.dataset.guideChoice;
      this.querySelectorAll('[data-guide-choice]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === activeButton));
      });
      this.querySelectorAll('[data-guide-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.guidePanel !== target;
      });
      this.querySelectorAll('[data-guide-shared]').forEach((element) => {
        element.hidden = false;
      });
    }
  }

  if (!customElements.get('ve-guide')) customElements.define('ve-guide', VeGuide);

  } catch(e) { console.error(e); }
})();
})();
